/* eslint-disable jsx-a11y/anchor-is-valid */
import DashboardHeader from "@/components/DashboardHeader/DashboardHeader";
import ProjectDetailsCard from "@/components/ProjectDetailsCard/ProjectDetailsCard";
import DashboardWrapper from "@/layout/wrapper/DashboardWrapper";
import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Pagination,
  styled,
} from "@mui/material";
// import Wrapper from "@/layout/wrapper/Wrapper";
import useNotiStack from "hooks/useNotistack";
import { useEffect, useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import assest from "@/json/assest";
import Image from "next/image";
import DashboardTable from "@/components/Tables/DashboardTable";
import SearchHeader from "@/components/SearchHeader/SearchHeader";
import PaginationFooter from "@/components/PaginationFooter/PaginationFooter";
import CustomButton from "@/ui/Buttons/CustomButton";
import DropDownButton from "@/components/DropDownButton/DropDownButton";
import { useDownloadCsv, useGetdashboardlist } from "@/hooks/useDashboard";
import DashboardProjectChart from "@/components/DashboardProjectChart";
import DashboardProjectpie from "@/components/DashboardProjectpie";
import DashboardProjectActiveUser from "@/components/DashboardProjectActiveUser";
import DashboardProjectTreeMap from "@/components/DashboardProjectTreeMap";
import Seo from "@/components/Seo/Seo";
import { baseUrlApi } from "./blog-details/[slug]";

//styled
const ProjectBoxWrapper = styled(Box)`
  .projectBoxWrapper {
    padding: 22px 0;
    .MuiGrid-container {
      .MuiGrid-item {
        &:nth-child(1) {
          .projectBox {
            .projectBoxImg {
              background: #fde9ec;
            }
          }
        }
        &:nth-child(2) {
          .projectBox {
            .projectBoxImg {
              background: #fff5ec;
            }
          }
        }
        &:nth-child(3) {
          .projectBox {
            .projectBoxImg {
              background: #f0fff5;
            }
          }
        }
        &:nth-child(4) {
          .projectBox {
            .projectBoxImg {
              background: #fdf4ff;
            }
          }
        }
      }
    }
  }
`;

const GraphWrapper = styled(Box)`
  .chartWrapper {
    background: #ffffff;
    border-radius: 5px;
    margin: 0 0 23px;
    padding: 23px 24px;
    .chartbody {
      text-align: center;
    }
  }
  .heightone {
    min-height: 460px;
  }
  .chartHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 32px;
    svg {
      color: #030229;
      opacity: 0.3;
    }
  }
  .chartHeader h4 {
    font-weight: 600;
    font-size: 16px;
    color: #003366;
    margin: 0;
  }
  .chartHeader button i {
    color: #030229;
    opacity: 0.3;
  }
  .chartHeader button {
    background: transparent;
    border: none;
  }
  .roundChartImg {
    text-align: center;
    position: relative;
    img {
      height: auto;
    }
  }
  .percentage {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .percentage h2 {
    font-weight: 800;
    font-size: 30px;
    line-height: 1.5;
    color: #4f4e69;
    margin: 0;
    @media (max-width: 1199px) {
      font-size: 20px;
    }
  }
  .percentage p {
    font-weight: 400;
    font-size: 16px;
    color: #4f4e69;
    @media (max-width: 1199px) {
      font-size: 11px;
    }
  }
  .roundChart {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media (max-width: 1199px) {
        flex-wrap: wrap;
      }
      @media (max-width: 899px) {
        flex-wrap: inherit;
      }
      li {
        display: flex;
        align-items: center;
        @media (max-width: 1400px) {
          padding: 0 5px;
        }
        @media (max-width: 1300px) {
          font-size: 11px;
        }
        span {
          width: 14px;
          height: 14px;
          border-radius: 5px;
        }
      }
    }
  }
  .roundChart ul li:nth-child(1) span {
    background: #00cbf0;
  }
  .roundChart ul li:nth-child(2) span {
    background: #776efa;
  }
  .roundChart ul li:nth-child(3) span {
    background: #ff80b5;
  }
  .roundChart ul li p {
    margin: 0 0 0 10px;
    font-weight: 600;
    font-size: 11px;
    color: #828282;
  }
`;

const SearchHeaderTxt = styled(Box)`
  .dashboardSearchFilter {
    max-width: 458px !important;
    flex-basis: 458px !important;
    justify-content: flex-end !important;
    .dashboardSearch {
      max-width: calc(100% - 212px) !important;
      flex-basis: calc(100% - 212px) !important;
      @media (max-width: 575px) {
        max-width: 100% !important;
        flex-basis: 100% !important;
      }
    }
    .dashboardFilter {
      max-width: 192px !important;
      flex-basis: 192px !important;
      margin: 0 0 0 20px !important;
      display: none !important;
      @media (max-width: 575px) {
        max-width: 100% !important;
        flex-basis: 100% !important;
        margin: 10px 0 0 0 !important;
      }
      .MuiOutlinedInput-input {
        padding: 12px 20px;
      }
      select {
        appearance: none;
      }
      .MuiSelect-icon {
        display: none;
      }
      button {
        border: none;
        padding: 0;
        background: transparent;
        svg {
          color: #a4a4a4;
          font-size: 20px;
        }
      }
    }
  }
`;

const TableWrapper = styled(Box)``;

const PagiNationWrapper = styled(Box)`
  .paginationWrapper {
    margin: 8px 0 25px;
  }
  .dashboardFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

function Home() {
  const { toastSuccess, toastError } = useNotiStack();

  // useEffect(() => {
  //   toastError("err");
  //   toastSuccess("This is success");
  // }, []);

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [value, setvalue] = useState("");
  const [selectedTab, setSelectedTab] = useState<string>('city');
  
  //console.log(value,"value")
  
  const {
    data: alldashboardDataList,
    // refetch: deleteRole,
    isFetching,
  } = useGetdashboardlist({
    per_page: 8,
    page: page,
    keyword: search,
    days_filter: !value ? "7" : Number(value),
    loc_filter: selectedTab
  });

  //console.log(alldashboardDataList, "alldashboardDataList");

  // const cardloop = [
  //   {
  //     textp: "Projects",
  //     textg4: alldashboardDataList?.new_projects,
  //     img: "/assets/images/totalprojectIcon.svg",
  //     counts: "1,000",
  //   },
  //   {
  //     textp: "Service Providers",
  //     textg4: alldashboardDataList?.new_provider,
  //     img: "/assets/images/serviceproviderIcon.svg",
  //     counts: "700",
  //   },
  //   {
  //     textp: "Clients",
  //     textg4: alldashboardDataList?.new_clients,
  //     img: "/assets/images/totalClientIcon.svg",
  //     counts: "10,000",
  //   },
  //   {
  //     textp: "App Downloads",
  //     textg4: alldashboardDataList?.app_downloads,
  //     img: "/assets/images/totalEarningIcon.svg",
  //     counts: "5000",
  //   },
  // ];
  // console.log(alldashboardDataList, "gokl");

  const { mutate: download } = useDownloadCsv();

  const downloadCsv = () => {
    download();
  };

  return (
    <DashboardWrapper name="Home">
      <Seo
        title="Wokka | DashBoard"
        canonical=""
        description=""
        url=""
        image=""
      />
      <section className="dashboardwrapper-serach">
        <DashboardHeader name="Overview">
          {/* <div className="download_button">
            
            <a href={`${baseUrlApi}/admin/log/download`} target="_blank" rel="noreferrer">
              <CustomButton type="button" onClick={downloadCsv}>
                <p>Download Active Log</p>
              </CustomButton>
            </a>
          </div> */}
          <SearchHeader
            hasIconsInFilter={true}
            name=""
            text=""
            value={search}
            className="search-wrapDashbrd"
            onChange={(e) => setSearch(e.target.value)}
          />
          <DropDownButton
            value={value}
            onChange={(e) => setvalue(e.target.value)}
          />
        </DashboardHeader>
      </section>

      <ProjectBoxWrapper>
        <Box className="projectBoxWrapper">
          <Grid container spacing={2}>
            {/* {cardloop.map((item, index) => { */}
            {/* return ( */}
            <Grid item lg={3} md={6} xs={12}>
              <ProjectDetailsCard
                item={{
                  textp: "Projects",
                  counts: alldashboardDataList?.new_projects,
                  img: "/assets/images/totalprojectIcon.svg",
                }}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <ProjectDetailsCard
                item={{
                  textp: "Service Providers",
                  counts: alldashboardDataList?.new_provider,
                  img: "/assets/images/serviceproviderIcon.svg",
                }}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <ProjectDetailsCard
                item={{
                  textp: "Clients",
                  counts: alldashboardDataList?.new_clients,
                  img: "/assets/images/totalClientIcon.svg",
                }}
              />
            </Grid>
            {/* <Grid item lg={3} md={6} xs={12}>
              <ProjectDetailsCard
                item={{
                  textp: "App Downloads",
                  counts: alldashboardDataList?.app_downloads,
                  img: "/assets/images/totalEarningIcon.svg",
                }}
              />
            </Grid> */}
            <Grid item lg={3} md={6} xs={12}>
              <ProjectDetailsCard
                item={{
                  textp: "Active users",
                  counts: alldashboardDataList?.active_users,
                  img: "/assets/images/activeuser.svg",
                }}
              />
            </Grid>

            {/* ); */}
            {/* })} */}
          </Grid>
        </Box>
      </ProjectBoxWrapper>

      <GraphWrapper>
        <Box className="graphWrapper">
          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <Box className="chartWrapper ">
                <Box className="chartHeader">
                  <h4>New Users</h4>
                  {/* <Button><MoreHorizIcon /></Button> */}
                </Box>

                <Box className="chartbody">
                  {/* <Image
                    src={assest.draphLineChart}
                    width={678}
                    height={290}
                    alt=""
                  /> */}
                  <DashboardProjectChart
                    alldashboardDataList={alldashboardDataList}
                  />
                  {/* <Apexlinechart width={678}
                    height={290}/> */}
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box className="chartWrapper heightone">
                <Box className="chartHeader">
                  <h4>Projects</h4>
                  {/* <Button><MoreHorizIcon /></Button> */}
                </Box>

                <Box className="chartbody" style={{ marginTop: "64px" }}>
                  <Box className="roundChart">
                    <Box className="roundChartImg roundimgone">
                      <DashboardProjectpie
                        alldashboardDataList={alldashboardDataList}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item md={4} xs={12}>
              <Box className="chartWrapper">
                <Box className="chartHeader">
                  <h4>Top 10 (Active Users)</h4>
                </Box>

                <DashboardProjectActiveUser
                  alldashboardDataList={alldashboardDataList}
                  setSelectedTab={setSelectedTab}
                  selectedTab={selectedTab}
                />
              </Box>
            </Grid>
            <Grid item md={12} xs={12}>
              <DashboardProjectTreeMap
                alldashboardDataList={alldashboardDataList}
              />
            </Grid>
          </Grid>
        </Box>
      </GraphWrapper>

      <SearchHeaderTxt>
        <Box>
          <h5>Active Projects</h5>
          <br />
          {/* <SearchHeader
            hasIconsInFilter={true}
            name="Active Projects"
            text=""
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          /> */}
        </Box>
      </SearchHeaderTxt>

      <TableWrapper>
        <Box className="tableWrapper">
          <DashboardTable Data={alldashboardDataList} />
        </Box>
      </TableWrapper>

      <PagiNationWrapper>
        <Box className="paginationWrapper">
          {/* <PaginationFooter /> */}

          <PaginationFooter
            count={alldashboardDataList?.pageCount}
            page={page}
            onChange={(_e, value) => setPage(value)}
            perPage={0}
          />
        </Box>
      </PagiNationWrapper>
    </DashboardWrapper>
  );
}
export default Home;
